/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Carrier_Select_PlaceholderInputs */

const vi_shipping_carrier_select_placeholder = /** @type {(inputs: Shipping_Carrier_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn đơn vị vận chuyển`)
};

/**

* @param {Shipping_Carrier_Select_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shipping_carrier_select_placeholder = /** @type {((inputs?: Shipping_Carrier_Select_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Carrier_Select_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shipping_carrier_select_placeholder(inputs)
});